// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__12jii","modalForm":"UpgradeEpcsModal_modalForm__1LboY","modalFooter":"UpgradeEpcsModal_modalFooter__YUTYf"};